import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogProps,
    DialogTitle,
    Typography,
} from '@material-ui/core';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Button } from '../buttons/Button';

interface IProps extends DialogProps {
    cancelProps: { text?: string; onClick(): void };
    className?: string;
    confirmProps: { text?: string; onClick(): void };
    title?: string;
}

const BaseConfirmDialog: React.FC<IProps> = ({
    cancelProps,
    children,
    className,
    confirmProps,
    open,
    title,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog className={className} open={open}>
            <DialogTitle disableTypography className="title">
                <Typography color="primary" variant="h5">
                    {title}
                </Typography>
            </DialogTitle>

            <DialogContent className="content">
                <DialogContentText className="contentText">
                    {children}
                </DialogContentText>
            </DialogContent>

            <DialogActions className="actions">
                <Button fullWidth small onClick={confirmProps.onClick}>
                    {confirmProps.text || t('dialogs.yes')}
                </Button>
                <Button fullWidth small onClick={cancelProps.onClick}>
                    {cancelProps.text || t('dialogs.no')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export const ConfirmDialog = styled(BaseConfirmDialog)`
    .MuiDialog-paper {
        width: 100%;
        max-width: 500px;
        padding: ${({ theme }) =>
            `${theme.spacing(7)}px ${theme.spacing(9)}px`};
        border: ${({ theme }) => `2px solid ${theme.palette.action.active}`};
        border-radius: 0;

        .title {
            padding: 0;
            margin-bottom: ${({ theme }) => `${theme.spacing(5)}px`};
        }

        .content {
            padding: 0;
            margin-bottom: ${({ theme }) => `${theme.spacing(5)}px`};
        }

        .contentText {
            font-size: 1rem;
            padding-top: 0;
        }

        .actions {
            display: block;
            padding: 0;

            ${Button} {
                background-color: ${({ theme }) => theme.palette.primary.main};
                margin-left: 0;

                :first-child {
                    background-color: ${({ theme }) =>
                        theme.palette.action.active};
                    margin-right: ${({ theme }) => `${theme.spacing(5)}px`};
                    margin-bottom: ${({ theme }) => `${theme.spacing(2)}px`};
                }
            }
        }

        @media (min-width: ${({ theme }) =>
                `${theme.breakpoints.values['sm']}px`}) {
            .actions {
                display: flex;

                ${Button}:first-child {
                    margin-bottom: 0;
                }
            }
        }
    }
`;
